import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef } from '@angular/material/dialog';
import { ImpactAssessmentFilter } from 'src/app/core/models/impact-assessment/impact-assessment-filter';
import { ImpactAssessmentListDto } from 'src/app/core/models/impact-assessment/impact-assessment-list';
import { ImpactAssessmentViewModel } from 'src/app/core/models/impact-assessment/impact-assessment-view-model';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { GDPRService } from 'src/app/core/services/rulebook/gdpr.service';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-append-assess-list',
  templateUrl: './append-assess-list.component.html',
  styleUrls: ['./append-assess-list.component.scss']
})
export class AppendAssessListComponent implements OnInit {
  templateNo = 0;
  endIndex = 0;
  impactAssessmentFilter: ImpactAssessmentFilter;
  impactAssessmentList: Array<ImpactAssessmentListDto>;
  selectedItemId = 0;
  selectedItems: Array<number>;
  selectedItem: number;
  updatedDbIds: Array<number>;
  authenticatedItems: Array<number>;
  selectedJuris: Array<string>;
  totalCount = 0;
  isLoading = false;
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  myInnerHeight: any;
  toastModel: ToastViewModel;
  isToastShow = false;
  filterPersistenceKey = 'regulationFilter';
  searchText = '';
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;
  keyCtrl = new FormControl();
  selectable = true;
  removable = true;
  addOnBlur = true;
  filteredKeywords: string[];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('viewport')
  viewport1!: ElementRef;
  constructor(
    private impactService: ImpactService,
    private gdprService: GDPRService,
    public dialogRef: MatDialogRef<AppendAssessListComponent>
  ) {
    this.myInnerHeight = window.innerHeight - 200;
    this.selectedItems = [];
    this.selectedItem = 0;
    this.updatedDbIds = [];
    this.impactAssessmentList = [];
    this.authenticatedItems = [];
    this.selectedJuris = [];
    this.impactAssessmentFilter = new ImpactAssessmentFilter();
    this.toastModel = new ToastViewModel();
    this.filteredKeywords = [];
  }
  ngOnInit(): void {
    
    this.impactAssessmentFilter.fromDate = MasterHelper.getDateStr(365);;
    this.impactAssessmentFilter.toDate = MasterHelper.getDateStr(0);
    this.fetchImpactAssessmentSummary();
  }
  async fetchImpactAssessmentSummary() {
    
    this.isLoading = true;
    let data: any = await this.gdprService.getTemplateNo().toPromise();
    this.templateNo = data.result;

    this.impactAssessmentFilter.filterType = 'InProgress';
    this.impactService
      .GetAllTypeImpactAssessmentList(this.impactAssessmentFilter)
      .subscribe((result: ImpactAssessmentViewModel) => {
        this.impactAssessmentList = this.impactAssessmentFilter.Page > 1 ? this.impactAssessmentList.concat(result.data) : result.data;
       this.totalCount = result.totalCount;
        this.isLoading = false;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        this.templateNo = result.templateNo;
      });
  }
  sortImpactAssessment(key: string): void {
    this.impactAssessmentFilter.IsDesc = !this.impactAssessmentFilter.IsDesc;
    this.impactAssessmentFilter.SortKey = key;
    this.fetchImpactAssessmentSummary();
  }
  selectItem(event: any, id: number, updatedDbId: number, jurisdiction: string): void {
    if (event === 'Checked') {
      this.selectedItem=id;
    }
    else{
      this.selectedItem=0;
    }
  }
  
  handler(event:any): void {
    this.endIndex = this.viewport.getRenderedRange().end;
    if ((this.endIndex % this.impactAssessmentFilter.PageSize) === 0 && (this.endIndex / this.impactAssessmentFilter.PageSize) === this.impactAssessmentFilter.Page) {
      this.impactAssessmentFilter.Page = this.impactAssessmentFilter.Page + 1;
      this.fetchImpactAssessmentSummary();
    }
  }
  getSelectedItems(id: number): boolean {
    return this.selectedItem === id ? true : false;
  }
  closeModal(): void {
    if (this.selectedItem> 0) {
      this.dialogRef.close(this.selectedItem);
    }
    else{
      this.warningAlert("Please select at least one assessment to append.");
    }
  }
  cancelModal(): void {
    this.dialogRef.close();

  }
  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
  
  keywordSearch(){
    this.impactAssessmentFilter.Page = 1;
    this.fetchImpactAssessmentSummary();
  }
  resetKeyWords(){
    this.impactAssessmentFilter.Page = 1;
    this.impactAssessmentFilter.fromDate = MasterHelper.getDateStr(365);;
    this.impactAssessmentFilter.toDate = MasterHelper.getDateStr(0);
    this.impactAssessmentFilter.searchQuery=[];
    this.keywordSearch();
  }
  // Keywords events
  addKeywords(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        this.impactAssessmentFilter.searchQuery.push(value.trim());
      }

      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }

  selectedKeywords(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.searchQuery) {
      this.impactAssessmentFilter.searchQuery.push(event.option.viewValue);
    } else {
      this.impactAssessmentFilter.searchQuery = [];
      this.impactAssessmentFilter.searchQuery.push(event.option.viewValue);
    }
    if(this.keywordInput){
      this.keywordInput.nativeElement.value = '';
    }
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  removeKeywords(searchstr: string): void {
    const index = (this.impactAssessmentFilter.searchQuery as string[]).indexOf(searchstr);

    if (index >= 0) {
      (this.impactAssessmentFilter.searchQuery as string[]).splice(index, 1);
    }
  }
}
